import Loadable from 'react-loadable';

const ForgeFullAppPage = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "ForgeFullAppPage" */ './ForgeFullAppPage'),
  loading: () => null,
});

export default ForgeFullAppPage;
